import classnames from 'classnames';
import IconSuccess from './icon_success.svg';
import IconWarning from './icon_warning.svg';
import IconError from './icon_error.svg';
import IconClose from './icon_close.svg';
import s from './index.module.scss';

const ICONS = {
  success: IconSuccess,
  warning: IconWarning,
  error: IconError,
};

export const InfoMessage = ({
  type,
  title,
  desc,
  onClose,
  className,
  mainLabel,
  mainAction,
  secondaryLabel,
  secondaryAction,
}) => {
  return (
    <div className={classnames(s.wrapper, className, type)}>
      <div className={s.icon}>
        <img src={ICONS[type]} alt={type} width={40} height={40} />
      </div>
      <div className={s.content}>
        <div className={classnames(s.title, 'f-small-accent-s')}>{title}</div>
        <div className={classnames(s.desc, 'f-small-regular')}>{desc}</div>
        {(mainAction || secondaryAction) && (
          <div className={s.buttons}>
            <button
              className={classnames(
                s.button,
                s.button_main,
                type,
                'f-small-accent-s',
              )}
              type="button"
              onClick={mainAction}
            >
              {mainLabel}
            </button>
            {secondaryAction && (
              <button
                type="button"
                className={classnames(
                  s.button,
                  s.button_secondary,
                  'f-small-accent-s',
                )}
                onClick={secondaryAction}
              >
                {secondaryLabel}
              </button>
            )}
          </div>
        )}
      </div>
      {onClose && (
        <button className={s.btn_close} type="button" onClick={onClose}>
          <img src={IconClose} alt="close" width={24} height={24} />
        </button>
      )}
    </div>
  );
};
